import { formatCurrencyWithCommas } from '@/utils/formatNumber';

export function formatPremium(premium: string | undefined): string {
    if (!premium) return '—';
    const numValue = parseFloat(premium);
    if (isNaN(numValue)) return premium;
    return formatCurrencyWithCommas(numValue);
}

